import { Link } from 'react-router-dom';

export default function ContentSection() {
  return (
    <section id="guides" className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="inline-block bg-foreground-900 text-background-50 text-[10px] tracking-wider uppercase px-3 py-1 rounded font-medium">
            / Editorial
          </span>
          <h2 className="text-foreground-900 font-heading text-4xl md:text-5xl font-bold mt-5 leading-[1.15]">
            GTBuy Sheet<br />Guides &amp; Comparisons
          </h2>
          <p className="text-foreground-500 text-base mt-4 max-w-xl leading-relaxed">
            Independent, original guides written to help you navigate spreadsheet sourcing platforms. No recycled content — every article is freshly researched.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          <Link
            to="/what-is-gtbuy-spreadsheet"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Close-up%20macro%20shot%20of%20fingertips%20touching%20a%20glowing%20holographic%20spreadsheet%20interface%20projected%20above%20a%20dark%20desk%2C%20futuristic%20data%20visualization%20with%20neon%20cyan%20grid%20lines%2C%20cyberpunk%20inspired%20tech%20photography%2C%20dark%20moody%20atmosphere%20with%20electric%20blue%20and%20magenta%20light%20trails%2C%20sleek%20sci-fi%20product%20showcase&width=600&height=360&seq=article-v2-a1b2c&orientation=landscape"
                alt="What Is GTBuy Spreadsheet"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">7 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                What Is GTBuy Spreadsheet? A Complete Beginner&apos;s Guide for 2026
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Learn everything about GTBuy Spreadsheet — how it works, why thousands of users rely on it for product sourcing, and how to get started with verified spreadsheet lists in minutes.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/gtbuy-spreadsheet-guide"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Aerial%20overhead%20view%20of%20a%20person%20organizing%20colorful%20sticky%20notes%20and%20printed%20spreadsheet%20pages%20across%20a%20large%20wooden%20conference%20table%2C%20top-down%20productivity%20photography%2C%20bright%20daylight%20from%20skylight%20above%2C%20organized%20chaos%20aesthetic%20with%20warm%20oak%20and%20pastel%20paper%20tones%2C%20creative%20workspace%20flat%20lay&width=600&height=360&seq=article-v2-d3e4f&orientation=landscape"
                alt="GTBuy Spreadsheet Guide"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">6 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                GTBuy Spreadsheet Guide: How to Use It Effectively in 2026
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                A step-by-step walkthrough of GTBuy Spreadsheet features, tips for finding the best verified sources, and strategies to make your product sourcing workflow faster and more reliable.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/kakobuy-spreadsheet-guide"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20held%20in%20hand%20displaying%20a%20mobile%20spreadsheet%20app%20interface%20with%20product%20thumbnails%2C%20urban%20cafe%20background%20with%20frosted%20window%20and%20espresso%20cup%2C%20lifestyle%20tech%20photography%2C%20warm%20ambient%20interior%20lighting%2C%20contrast%20between%20digital%20screen%20glow%20and%20cozy%20brick%20and%20wood%20textures%2C%20relatable%20everyday%20tech%20scene&width=600&height=360&seq=article-v2-g5h6i&orientation=landscape"
                alt="Kakobuy Spreadsheet Guide"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">5 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Kakobuy Spreadsheet Explained: Features, Benefits &amp; Setup
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Discover the Kakobuy Spreadsheet platform — a popular alternative for budget-conscious sourcers. Compare its features, learn how to navigate the interface, and find verified sources.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/superbuy-spreadsheet-guide"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Multiple%20transparent%20glass%20panels%20layered%20in%20space%20each%20with%20different%20spreadsheet%20data%20projections%20floating%20at%20different%20depths%2C%20conceptual%20data%20visualization%20art%20installation%2C%20gallery%20lighting%20with%20soft%20spotlights%2C%20ethereal%20translucent%20layers%20with%20subtle%20rainbow%20refractions%2C%20avant-garde%20tech%20art%20photography&width=600&height=360&seq=article-v2-j7k8l&orientation=landscape"
                alt="Superbuy Spreadsheet Guide"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">6 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Superbuy Spreadsheet: The Advanced Sourcing Tool Explained
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Superbuy Spreadsheet is designed for power users who need advanced filtering and bulk operations. Learn how it differs from other platforms and whether it is right for your workflow.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/spreadsheet-comparison"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Wide%20angle%20shot%20of%20a%20collaborative%20workspace%20with%20three%20diverse%20people%20pointing%20at%20a%20large%20wall-mounted%20monitor%20showing%20comparison%20charts%2C%20modern%20open%20office%20with%20living%20green%20wall%20backdrop%2C%20natural%20daylight%20mixed%20with%20warm%20pendant%20lights%2C%20authentic%20teamwork%20photography%2C%20vibrant%20indoor%20plants%20against%20sleek%20glass%20and%20steel%20architecture&width=600&height=360&seq=article-v2-m9n0o&orientation=landscape"
                alt="Spreadsheet Comparison"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">8 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                GTBuy vs Kakobuy vs Superbuy: Full Spreadsheet Platform Comparison
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                A detailed head-to-head comparison of the three major spreadsheet sourcing platforms. We evaluate update frequency, reliability, ease of use, and which one suits your needs best.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/spreadsheet-safety"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Extreme%20close-up%20of%20a%20stainless%20steel%20padlock%20and%20chain%20resting%20on%20a%20printed%20spreadsheet%20document%20with%20security%20watermark%20patterns%20visible%2C%20cybersecurity%20concept%20photography%2C%20dramatic%20low-key%20lighting%20with%20single%20harsh%20spotlight%2C%20metallic%20silver%20against%20deep%20black%20background%2C%20tension%20filled%20editorial%20style%20with%20shallow%20depth%20of%20field&width=600&height=360&seq=article-v2-p1q2r&orientation=landscape"
                alt="Spreadsheet Safety Checklist"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">5 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Spreadsheet Safety Checklist: How to Verify Sources in 2026
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Stay safe while using spreadsheet sourcing platforms. This comprehensive safety guide covers verification methods, red flags to watch for, and best practices for secure browsing.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/best-gtbuy-spreadsheet-sources"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20hovering%20over%20a%20printed%20spreadsheet%20revealing%20hidden%20verification%20checkmarks%20and%20golden%20approval%20stamps%2C%20detective%20investigation%20aesthetic%2C%20warm%20desk%20lamp%20lighting%20against%20dark%20wood%20desk%20surface%2C%20trust%20and%20verification%20concept%20photography%2C%20sepia%20and%20gold%20tones%20with%20antique%20paper%20textures&width=600&height=360&seq=article-v2-s3t4u&orientation=landscape"
                alt="Best GTBuy Spreadsheet Sources"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">7 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Best GTBuy Spreadsheet Sources: Verified Links for 2026
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Discover the most reliable and frequently updated GTBuy Spreadsheet sources. We evaluate dozens of options and rank them by update frequency, accuracy, and community trust.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/free-gtbuy-spreadsheet-list"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=An%20open%20notebook%20filled%20with%20handwritten%20spreadsheet%20notes%20and%20colorful%20highlighters%20scattered%20across%20a%20sunlit%20picnic%20blanket%20in%20a%20green%20park%2C%20outdoor%20study%20lifestyle%20photography%2C%20dappled%20sunlight%20through%20tree%20leaves%2C%20vibrant%20stationery%20colors%20against%20fresh%20grass%20green%2C%20joyful%20learning%20and%20discovery%20atmosphere&width=600&height=360&seq=article-v2-u5v6w&orientation=landscape"
                alt="Free GTBuy Spreadsheet Lists"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">5 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Free GTBuy Spreadsheet Lists: Where to Find Quality Sources
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Not every good spreadsheet costs money. Learn where to find free, high-quality GTBuy Spreadsheet lists that are regularly maintained and community-verified.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/premium-spreadsheet-tools"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20sleek%20black%20credit%20card%20standing%20upright%20next%20to%20a%20glowing%20tablet%20screen%20showing%20premium%20dashboard%20features%2C%20luxury%20tech%20product%20photography%2C%20dark%20sophisticated%20ambiance%20with%20subtle%20gold%20rim%20lighting%2C%20premium%20subscription%20concept%2C%20midnight%20black%20and%20champagne%20gold%20tones%20with%20reflective%20surfaces&width=600&height=360&seq=article-v2-w7x8y&orientation=landscape"
                alt="Premium Spreadsheet Tools"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">6 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Premium Spreadsheet Tools Worth Paying For in 2026
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                An honest review of paid spreadsheet tools and platforms. We break down pricing, features, and whether the premium tier actually delivers better results than free alternatives.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/spreadsheet-update-frequency"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vintage%20wall%20clock%20with%20multiple%20time%20zone%20faces%20and%20a%20calendar%20marked%20with%20red%20circles%20beside%20an%20open%20laptop%2C%20time%20management%20concept%20photography%2C%20warm%20afternoon%20light%20through%20venetian%20blinds%20casting%20stripe%20shadows%2C%20ticking%20urgency%20aesthetic%2C%20rich%20mahogany%20and%20brass%20tones%20with%20paper%20calendar%20textures&width=600&height=360&seq=article-v2-z9a0b&orientation=landscape"
                alt="Spreadsheet Update Frequency"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">5 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                How Often Are Spreadsheet Lists Updated? A Complete Guide
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Update frequency can make or break your sourcing strategy. We analyze GTBuy, Kakobuy, and Superbuy update schedules so you know exactly when to check for new data.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/verified-spreadsheet-database"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Hands%20carefully%20placing%20labeled%20file%20folders%20into%20a%20metal%20filing%20cabinet%20drawer%20with%20colorful%20tab%20dividers%20visible%2C%20organized%20archive%20photography%2C%20bright%20clean%20office%20lighting%2C%20systematic%20filing%20aesthetic%2C%20crisp%20white%20folders%20with%20rainbow%20tab%20colors%20against%20gray%20steel%20cabinet%2C%20methodical%20knowledge%20management&width=600&height=360&seq=article-v2-c1d2e&orientation=landscape"
                alt="Verified Spreadsheet Database"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">7 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Verified Spreadsheet Database: How to Build Your Own
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Why rely entirely on third-party platforms? Follow this step-by-step guide to building your own verified spreadsheet database that you control and maintain.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/gtbuy-vs-kakobuy"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Two%20chess%20pieces%20a%20knight%20and%20a%20bishop%20facing%20each%20other%20on%20a%20chessboard%20with%20spreadsheet%20data%20printed%20on%20the%20squares%2C%20strategic%20comparison%20concept%20photography%2C%20dramatic%20overhead%20spotlight%20with%20long%20shadows%2C%20black%20and%20white%20contrast%20with%20warm%20cream%20board%20tones%2C%20competitive%20analysis%20editorial&width=600&height=360&seq=article-v2-f3g4h&orientation=landscape"
                alt="GTBuy vs Kakobuy"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">6 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                GTBuy vs Kakobuy Spreadsheet: Which One Wins in 2026?
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                A focused head-to-head matchup between the two most popular spreadsheet platforms. We compare category coverage, update speed, and overall reliability side by side.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/superbuy-vs-gtbuy"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20split%20frame%20composition%20with%20one%20side%20showing%20a%20minimalist%20clean%20workspace%20and%20the%20other%20showing%20a%20complex%20multi-monitor%20power%20user%20setup%2C%20dual%20lifestyle%20photography%2C%20natural%20light%20on%20left%20and%20blue%20monitor%20glow%20on%20right%2C%20beginner%20versus%20expert%20contrast%2C%20modern%20architectural%20interior%20with%20glass%20partitions&width=600&height=360&seq=article-v2-i5j6k&orientation=landscape"
                alt="Superbuy vs GTBuy"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">6 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Superbuy vs GTBuy Spreadsheet: Detailed Comparison for Power Users
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                Advanced users need advanced tools. This detailed comparison focuses on filtering capabilities, bulk operations, and the features that matter most for high-volume sourcing.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/gtbuy-spreadsheet-list-2026"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20treasure%20chest%20overflowing%20with%20golden%20USB%20drives%20and%20glowing%20data%20crystals%20on%20an%20antique%20world%20map%2C%20fantasy%20treasure%20meets%20modern%20data%20concept%2C%20warm%20candlelight%20and%20magical%20golden%20glow%2C%20adventurous%20discovery%20photography%2C%20rich%20mahogany%20wood%20with%20brilliant%20gold%20and%20amber%20luminescence&width=600&height=360&seq=article-v2-l7m8n&orientation=landscape"
                alt="GTBuy Spreadsheet List 2026"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">8 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                GTBuy Spreadsheet List 2026: The Ultimate Collection
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                The definitive roundup of every significant GTBuy Spreadsheet source available in 2026. Bookmark this page — we update it monthly with new verified links and categories.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>

          <Link
            to="/spreadsheet-beginners-guide"
            className="block break-inside-avoid bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:bg-background-200/30 transition-colors"
          >
            <div className="h-[180px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20friendly%20golden%20retriever%20puppy%20sitting%20next%20to%20an%20open%20laptop%20on%20a%20cozy%20rug%20with%20a%20steaming%20mug%20nearby%2C%20warm%20fireplace%20glow%20in%20background%2C%20comforting%20beginner%20friendly%20lifestyle%20photography%2C%20soft%20knit%20blanket%20textures%20and%20gentle%20orange%20firelight%2C%20welcoming%20learn%20from%20home%20atmosphere&width=600&height=360&seq=article-v2-o9p0q&orientation=landscape"
                alt="Spreadsheet Beginners Guide"
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5 md:p-6">
              <span className="text-foreground-400 text-xs font-medium">5 min read</span>
              <h3 className="text-foreground-900 text-lg font-semibold mt-2 leading-snug group-hover:text-primary-500 transition-colors">
                Spreadsheet Sourcing for Beginners: Start Here in 2026
              </h3>
              <p className="text-foreground-500 text-sm mt-2.5 leading-relaxed line-clamp-3">
                New to spreadsheet-based product sourcing? This beginner-friendly guide covers everything from basic terminology to your first successful product discovery in under 10 minutes.
              </p>
              <span className="inline-block text-primary-500 text-sm font-medium mt-4 border-b border-primary-500 pb-0.5 group-hover:border-primary-600 transition-colors">
                Read Article &rarr;
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}